import { graphql } from '@graphql/gql';

export const HEARTBEAT = graphql(`
  mutation HEARTBEAT($heartbeatInput: HeartbeatInput!) {
    heartbeatV2(heartbeatInput: $heartbeatInput) {
      sessionExtendedStatus
      encounterPublished
      boothStaffAvailabilityHeartbeatStatus
    }
  }
`);
